import { useCallback } from 'react';

import {
  ReactSelectAsyncInput,
  ReactSelectAsyncCreatableInput,
} from '@hivebrite/design-system/Inputs';

import { makeFetchTerm } from '../utils';

export const ReactSelectIndustriesOrKeyword = (props) => (
  <ReactSelectAsyncCreatableInput
    {...props}
    defaultOptions={false}
    loadOptions={makeFetchTerm({
      url: Routes.search_industries_path({ format: 'json' }),
    })}
    formatCreateLabel={useCallback((s) => `${__('Search for')}: ${s}`, [])}
    allowCreateWhileLoading
    createOptionPosition="first"
    isValidNewOption={() => true} // Since we use this for keyword search, any value is valid (even ones that match an existing industry)
  />
);

export const ReactSelectIndustries = (props) => (
  <ReactSelectAsyncInput
    {...props}
    noOptionsMessage={useCallback(
      ({ inputValue }) =>
        inputValue
          ? __('Industry %{industry} not found').i__({
              industry: inputValue,
            })
          : __('Search for a industry'),
      [],
    )}
    defaultOptions={false}
    loadOptions={makeFetchTerm({
      url: Routes.search_industries_path({ format: 'json' }),
    })}
  />
);

export const ReactSelectSkills = (props) => (
  <ReactSelectAsyncInput
    {...props}
    noOptionsMessage={useCallback(
      ({ inputValue }) =>
        inputValue
          ? __('Skill %{skill} not found').i__({
              skill: inputValue,
            })
          : __('Search for a skill'),
      [],
    )}
    defaultOptions={false}
    placeholder={__('Type a keyword')}
    loadOptions={makeFetchTerm({
      url: Routes.search_skills_path({ format: 'json' }),
    })}
  />
);
